// ============================================================
//  CLOUDINARY · subida de comprobantes (sin backend, sin tarjeta)
//
//  Crea una cuenta gratis en https://cloudinary.com y completa:
//   1. CLOUD_NAME  -> está en el Dashboard ("Cloud name").
//   2. UPLOAD_PRESET -> Settings (⚙️) > Upload > "Upload presets"
//      > Add upload preset > Signing Mode: "Unsigned" > Save.
//      Copia el nombre del preset aquí.
// ============================================================
export const CLOUDINARY_CLOUD_NAME = "dtonazy9w";
export const CLOUDINARY_UPLOAD_PRESET = "banosrun";

// Carpeta donde se guardan los comprobantes dentro de Cloudinary (opcional).
const CARPETA = "comprobantes";

// Sube una imagen a Cloudinary (modo "unsigned") y devuelve su URL pública segura.
export async function subirImagenCloudinary(file: File): Promise<string> {
  const url = `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/image/upload`;

  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);
  formData.append("folder", CARPETA);

  const res = await fetch(url, { method: "POST", body: formData });
  if (!res.ok) {
    const detalle = await res.text();
    throw new Error(`Cloudinary respondió ${res.status}: ${detalle}`);
  }

  const data = await res.json();
  return data.secure_url as string;
}
